import { useEffect, useState } from 'react';
import type { TelegramWebApp, TelegramUser } from './types.js';

export function useTelegram() {
  const [tg, setTg] = useState<TelegramWebApp | null>(() => {
    return typeof window !== 'undefined' ? window.Telegram?.WebApp ?? null : null;
  });
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;
    if (webApp) {
      webApp.ready();
      webApp.expand();
      setTg(webApp);
      setIsReady(true);
    }
  }, []);

  const initData = tg?.initData || (typeof window !== 'undefined' ? window.Telegram?.WebApp?.initData : '') || '';
  const user: TelegramUser | undefined = tg?.initDataUnsafe?.user || (typeof window !== 'undefined' ? window.Telegram?.WebApp?.initDataUnsafe?.user : undefined);

  return {
    tg,
    user,
    initData,
    isReady,
  };
}
